module.exports = __webpack_public_path__ + "img/microsoft-security-update-firewall.a4306f74.webp";